var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrokenLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/broken_link"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.994 7.564 3.45-3.45c3.338-3.338 8.86 2.184 5.522 5.522l-3.45 3.45c-1.43 1.43-3.824 1.352-5.35-.173m3.682 3.681-3.45 3.45c-3.338 3.338-8.86-2.184-5.522-5.521l3.45-3.45c1.43-1.43 3.824-1.352 5.349.172m6.378 8.808-2.065-2.065M6.012 6.012 3.947 3.947m11 19.053-.755-2.82M9.808 3.82 9.053 1M23 14.947l-2.82-.755M3.82 9.808 1 9.053",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenLink);
export default __webpack_public_path__ + "static/media/broken_link.4f41d2024e6afb7bd939550d11f54cef.svg";
export { ForwardRef as ReactComponent };